export default __webpack_public_path__ + "static/media/grad-laptop.ebfcc13d.png";